import Konva from "konva";
import { RefObject } from "react";

// Get all selectable nodes in the layer
// TODO: this is a duplicate of the function in canvas-stage.tsx. we need to refactor this to be a single function.
export function getSelectableNodes(layerRef: RefObject<Konva.Layer>, filterFn?: (i: any) => boolean): Konva.Node[] {
  if (!layerRef.current) return [];
  if (filterFn) {
    return layerRef.current.find((i: any) => i.attrs?.isCanvasElement && !i.hidden && filterFn(i)).toArray();
  } else {
    return layerRef.current.find((i: any) => i.attrs?.isCanvasElement && !i.hidden).toArray();
  }
}
